// extracted by mini-css-extract-plugin
export default {"home-wrapper":"home_home-wrapper__todS9","home-content":"home_home-content__Stp2u","home-links":"home_home-links__sZgAX","home-link":"home_home-link__WssF-"};